import Vapi from "vuex-rest-api";
import { API_URL } from "../config";
import Chance from "chance";
import times from "lodash.times";
const chance = new Chance();

// 15 seconds to firefly * 15 to full jar = about 4 minutes to a full jar
export const TIME_TO_FIREFLY = 15 * 1000;
// Testing version
// export const TIME_TO_FIREFLY = 1000;
export const FULL_COUNT = 15;
export const JAR_COUNT = 3;

const fireflies = new Vapi({
  baseURL: API_URL,
  state: {
    jars: [],
    treeColors: []
  }
})
  .get({
    action: "getTreeColors",
    property: "treeColors",
    path: "/tree-colors"
  })
  .getStore();

const getters = {
  fullJars(state) {
    return state.jars.filter(jar => jar.fireflies >= FULL_COUNT);
  }
};

fireflies.getters = fireflies.getters || {};
Object.assign(fireflies.getters, getters);

function newJar(state) {
  const existingColors = state.jars.map(jar => jar.color);
  const color = chance.pickone(
    state.treeColors.filter(color => !existingColors.includes(color.display))
  );
  return {
    color: color.display,
    led: color.led,
    fireflies: 0
  };
}

const mutations = {
  SET_JARS(state, jars) {
    state.jars = jars;
  },

  ADD_NEW_JAR(state) {
    state.jars.push(newJar(state));
  },

  REPLACE_JAR(state, jar) {
    state.jars.splice(state.jars.indexOf(jar), 1, newJar(state));
  },

  ADD_FIREFLY(state) {
    const stillNotFull = state.jars.filter(jar => jar.fireflies < FULL_COUNT);
    if (stillNotFull.length > 0) {
      const jar = chance.pickone(stillNotFull);
      if (jar) {
        jar.fireflies++;
      }
    }
  }
};

Object.assign(fireflies.mutations, mutations);

const actions = {
  getNewJars({ commit }) {
    commit("SET_JARS", []);
    times(JAR_COUNT, _ => {
      commit("ADD_NEW_JAR");
    });
  },

  addFirefly({ commit }) {
    commit("ADD_FIREFLY");
  },

  releaseJar({ commit }, jar) {
    commit("REPLACE_JAR", jar);
  }
};

Object.assign(fireflies.actions, actions);

export default fireflies;
